<div class="pm-tabs" role="tablist">
    <button
        *ngFor="let t of tabs"
        type="button"
        role="tab"
        class="pm-tab"
        [class.active]="t.key === activeKey"
        [attr.data-tab]="t.key"
        (click)="select(t.key)"
    >
        {{ t.label }}
        <span class="pm-tab-n" *ngIf="t.count !== null && t.count !== undefined">{{ t.count }}</span>
    </button>
</div>
